import React from 'react';
import {deleteSnapshot} from "../../redux/actions";
import {connect} from "react-redux";

const SnapshotListItem = ({ url, snapshot, renderSavedSnapshot, deleteSnapshot, selectedSpecimen}) => {

  return (
    <div className="snapshot-listitem">
	    <div className="snapshot-listitem-position">
	    	<img src={`data:image/png;${url}`} alt="Saved snapshot" onClick={() => renderSavedSnapshot(snapshot)} />
	      	{snapshot.note && <div className="snapshot-listitem-notes"><span>notes added</span></div>}

        <button
          className="snapshot-delete"
          onClick={() => deleteSnapshot(snapshot._id, selectedSpecimen._id)}
        />
      </div>
    </div>
  );
};

const mapStateToProps = ({_case}) => {
  const {selectedSpecimen} = _case;
  return {selectedSpecimen}
};

export default connect(mapStateToProps, {deleteSnapshot})(SnapshotListItem);
